// import { setLocale } from 'yup';

// setLocale({
//     mixed: {
//         required: '${mixed} là trường bắt buộc'
//     },
//     // number: {
//     //     moreThan: '',
//     // }
// })
export default {
  mixed: {
    notType: 'Vui lòng nhập  giá trị hợp lệ',
  },
  number: {
    min: '${path} phải lớn hơn hoặc bằng ${min}',
    moreThan: '${path} phải lớn hơn ${more}',
    lessThan: '${path} phải nhỏ hơn hoặc bằng ${less}',
  },
  string: {
    min: '${path} phải có ít nhất ${min} ký tự',
  },
};
